import { render, staticRenderFns } from "./ModuleTOC.vue?vue&type=template&id=848ee98c"
import script from "./ModuleTOC.vue?vue&type=script&lang=js"
export * from "./ModuleTOC.vue?vue&type=script&lang=js"
import style0 from "./ModuleTOC.vue?vue&type=style&index=0&id=848ee98c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports